var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"organization"},[_c(_vm.component,{tag:"div",attrs:{"objData":_vm.Data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }